// import gsap from "gsap";
import { Surface } from "./Surface";
import * as THREE from "three";

export const startGlobus = () => {
    const container = document.querySelector(".animation-wrapper");
    const globeCanvas = container.querySelector("#globe-3d");
    const globeOverlayCanvas = container.querySelector("#globe-2d-overlay");
    const popup = container.querySelector(".globe-popup");

    let surface = new Surface(popup, container, globeCanvas, globeOverlayCanvas);

    new THREE.TextureLoader().load("/images/earth-map.jpeg", (mapTex) => {
        surface.earthTexture = mapTex;
        surface.earthTexture.repeat.set(1, 1);
        surface.earthTextureData = surface.getImageData();
        surface.createGlobe();
        surface.addAnchor();
        surface.updateDotSize();
        surface.loop();
    });

    // gsap.to(".title", {
    //     delay: 5,
    //     duration: 0.2,
    //     opacity: 1,
    // });
};
